module.exports = __webpack_public_path__ + "static/logo_Noble-e77935077c9c992d7c6bc1a3f7f4c397.png";